import { buildModelManager } from "../builder.js";
const DefaultShiftSelection = {
  __typename: true,
  id: true,
  actualPatients: true,
  agencyId: true,
  availableSpots: true,
  clinicalSiteId: true,
  cohortId: true,
  createdAt: true,
  deletedAt: true,
  deletedById: true,
  deletionReason: true,
  department: true,
  endTime: true,
  enrollmentPeriodEnd: true,
  enrollmentPeriodStart: true,
  fisdapEventUid: true,
  fisdapInstructorName: true,
  fisdapUrl: true,
  institution: true,
  isDeleted: true,
  isOpenEnrollment: true,
  isOrExempt: true,
  lastSyncedAt: true,
  location: true,
  locked: true,
  maxStudents: true,
  notes: { markdown: true, truncatedHTML: true },
  objectives: { markdown: true, truncatedHTML: true },
  preceptorId: true,
  preceptorNotes: { markdown: true, truncatedHTML: true },
  requiresPreceptorApproval: true,
  shiftDate: true,
  shiftRequirements: true,
  shiftType: true,
  status: true,
  syncMetadata: true,
  syncSource: true,
  unit: true,
  unlockRequestNotes: true,
  unlockRequestReason: true,
  unlockRequestStatus: true,
  unlockRequested: true,
  unlockRequestedAt: true,
  unlockRequestedById: true,
  updatedAt: true
};
const modelApiIdentifier = "shift";
const pluralModelApiIdentifier = "shifts";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShiftSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createShift",
    operationReturnType: "CreateShift",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { shift: { required: false, type: "CreateShiftInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "bulkCreateShifts",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkCreateShiftsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "updateShift",
    operationReturnType: "UpdateShift",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      shift: { required: false, type: "UpdateShiftInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateShifts",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpdateShiftsInput!]" } },
    paramOnlyVariables: [],
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "deleteShift",
    operationReturnType: "DeleteShift",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteShifts",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "enrollStudentShift",
    operationReturnType: "EnrollStudentShift",
    functionName: "enrollStudent",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      studentId: { required: false, type: "String" },
      studentEmail: { required: false, type: "String" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["studentId", "studentEmail"],
    hasReturnType: true,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "bulkEnrollStudentShifts",
    functionName: "bulkEnrollStudent",
    isBulk: true,
    isDeleter: false,
    hasReturnType: true,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "enrollStudent",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkEnrollStudentShiftsInput!]" }
    },
    paramOnlyVariables: ["studentId", "studentEmail"],
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "upsertShift",
    operationReturnType: "UpsertShift",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      shift: { required: false, type: "UpsertShiftInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateShiftResult": { hasReturnType: false },
      "... on UpdateShiftResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertShifts",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { inputs: { required: true, type: "[BulkUpsertShiftsInput!]" } },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultShiftSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shiftGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ShiftManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShiftSelection,
  operations
);
export {
  DefaultShiftSelection,
  ShiftManager
};
//# sourceMappingURL=Shift.js.map
